import styled from 'styled-components'
import { brandPalette as palette } from '../../styles/abstracts/_variables.styles'

export const ForecastMain = styled.main`
  color:${palette.ink}; padding:11.6rem 0 7rem;
  --forecast-line:rgba(24,47,53,.2);
  h1,h2,h3 { font-family:'Whyte-Bold',sans-serif; letter-spacing:-.025em; line-height:1.15; }
  h1 { font-size:clamp(3.8rem,5.3vw,6.8rem); margin:1.6rem 0; max-width:22ch; text-wrap:balance; }
  h2 { font-size:clamp(2.6rem,3vw,3.6rem); margin:0 0 1.2rem; }
  h3 { font-size:2.2rem; margin:0; }
  p { margin:.8rem 0; }
  a:not([data-beach-link]) { text-decoration:underline; text-underline-offset:.3rem; }
  @media(max-width:899px) { padding-top:9.2rem; }
  @media(max-width:479px) { padding-bottom:4rem; }
`
export const ForecastWidth = styled.div`width:min(118rem,calc(100% - 4rem)); margin:0 auto; min-width:0; @media(max-width:359px){width:calc(100% - 3.2rem);}`
export const ForecastIntro = styled.div`
  display:grid; grid-template-columns:1.4fr 1fr; gap:5rem; align-items:end; padding-bottom:3rem;
  > div > p { font-size:1.8rem; max-width:53ch; }
  aside { max-width:43ch; padding-bottom:.4rem; }
  aside p { font-size:1.6rem; }
  @media(max-width:767px){grid-template-columns:1fr; gap:1rem; padding-bottom:2.4rem; aside{max-width:60ch;} }
`
export const Breadcrumb = styled.nav`font-size:1.4rem; display:flex; gap:1rem; align-items:center; flex-wrap:wrap;`
export const BeachNav = styled.nav`
  display:flex; flex-wrap:wrap; gap:.8rem; padding-bottom:2.8rem;
  a { border:1px solid var(--forecast-line); border-radius:3rem; padding:1rem 1.9rem; font-size:1.55rem; min-height:4.8rem; display:flex; align-items:center; }
  a[aria-current="page"] { background:${palette.ink}; color:${palette.chalk}; border-color:${palette.ink}; }
  a:hover { border-color:${palette.ink}; }
  @media(max-width:479px){gap:.7rem; a{padding:.9rem 1.35rem; font-size:1.4rem;} }
`
export const CurrentBand = styled.section`
  background:${palette.ink}; color:${palette.chalk}; border-radius:.8rem; padding:2.5rem 3rem 2.8rem;
  > p { color:${palette.seaGlass}; font-size:1.5rem; margin:0 0 1.8rem; }
  dl { display:grid; grid-template-columns:repeat(5,minmax(0,1fr)); margin:0; gap:2rem; }
  dl > div:not(:first-child){border-left:1px solid rgba(255,255,255,.22); padding-left:2.5rem;}
  dt { font-size:1.5rem; color:${palette.seaGlass}; margin-bottom:.8rem; }
  dd { margin:0; font-size:clamp(2.8rem,3vw,4rem); line-height:1.2; font-variant-numeric:tabular-nums; }
  dd small { font-size:1.6rem; }
  [data-reading="tide"] dd { font-size:2.8rem; }
  [data-reading="tide"] dd[data-unavailable="true"] { font-size:1.6rem; }
  .tide-next { margin-top:.7rem; overflow-wrap:anywhere; } .tide-next b{font-weight:600;}
  [data-reading="tide"] .detail{font-size:1.3rem;line-height:1.6;}
  .detail { display:block; font-size:1.4rem; margin-top:.9rem; line-height:1.7; }
  @media(max-width:767px){padding:2.2rem; dl{grid-template-columns:repeat(2,minmax(0,1fr)); gap:2.3rem 1.5rem;} dl>div:not(:first-child){padding-left:0;border-left:0;} dl>div:nth-child(even){padding-left:1.5rem;border-left:1px solid rgba(255,255,255,.22);} dl>div:last-child{grid-column:1/-1;} [data-reading="tide"] dd{font-size:2.5rem;} }
`
export const DirectionWrap = styled.span`display:inline-flex; align-items:center; gap:.4rem; white-space:nowrap; svg{width:1.7rem;height:1.7rem;flex:none;}`
export const StatusLine = styled.div`
  display:flex; flex-wrap:wrap; justify-content:space-between; align-items:center; gap:1.2rem; padding:1.5rem 0 2.8rem; font-size:1.4rem;
  p { margin:0; max-width:75ch; }
`
export const Control = styled.button`
  background:transparent; border:1px solid var(--forecast-line); border-radius:.4rem; padding:.8rem 1.5rem; min-height:4.4rem; cursor:pointer; color:inherit; font-size:1.4rem;
  &:hover { background:${palette.seaGlass}; } &:disabled{opacity:.6;cursor:wait;}
`
export const Notice = styled.p`padding:1.5rem 2rem; border-left:3px solid ${palette.brass}; background:${palette.chalk}; font-size:1.5rem;`
export const ForecastSection = styled.section`padding:2.8rem 0; border-top:1px solid var(--forecast-line); min-width:0; >p{font-size:1.5rem;max-width:75ch;}`
export const DayNav = styled.div`
  display:grid; grid-template-columns:repeat(7,minmax(0,1fr)); gap:.6rem; margin:2rem 0 2.8rem; overflow-x:auto; padding:4px;
  button { text-align:left; color:inherit; background:transparent; border:1px solid var(--forecast-line); border-radius:.5rem; padding:1.4rem 1.1rem; min-width:0; cursor:pointer; }
  button:hover { border-color:${palette.ink}; }
  button[aria-pressed="true"] { background:${palette.ink}; color:${palette.chalk}; }
  span,strong,small { display:block; } span{font-size:1.35rem;} strong{font-size:1.8rem;margin:.6rem 0;font-weight:600;white-space:nowrap;} small{font-size:1.2rem;}
  @media(max-width:899px){grid-template-columns:repeat(7,minmax(13rem,1fr));}
`
export const ChartPanel = styled.div`
  padding:2rem 2.5rem 1.2rem; background:${palette.chalk}; border-radius:.6rem; min-width:0;
  svg { display:block; width:100%; height:auto; overflow:visible; font-family:'AvenirNextLTPro-Regular',sans-serif; }
  svg text { fill:${palette.ink}; font-size:13px; }
  @media(max-width:479px){padding:1.8rem 1.4rem 1rem; svg text{font-size:13px;} }
`
export const ChartHeading = styled.div`display:flex; justify-content:space-between; align-items:baseline; gap:1rem; flex-wrap:wrap; p{font-size:1.4rem;}`
export const Legend = styled.div`
  display:flex; gap:1.8rem; flex-wrap:wrap; font-size:1.4rem; margin:1rem 0;
  span { display:inline-flex;align-items:center;gap:.7rem; }
  i { display:inline-block;width:2rem;border-top:3px solid ${palette.ink}; }
  i[data-line="swell"]{border-top-style:dashed;border-color:${palette.brass};}
`
export const TableScroll = styled.div`
  overflow-x:auto; margin-top:1.5rem; border:1px solid var(--forecast-line); border-radius:.5rem;
  table { width:100%; min-width:88rem; border-collapse:collapse; font-size:1.4rem; text-align:left; font-variant-numeric:tabular-nums; background:${palette.chalk}; }
  caption { text-align:left; padding:1.4rem 1.6rem; font-size:1.4rem; }
  th,td { padding:1.2rem 1.6rem; border-top:1px solid var(--forecast-line); vertical-align:top; }
  thead th { background:${palette.limestone}; font-weight:600; }
  tbody th { white-space:nowrap; }
  tbody tr[data-current="true"] { background:rgba(181,198,193,.3); }
  td span[data-secondary] { display:block; font-size:1.25rem; }
`
export const ReadingGrid = styled.div`
  display:grid; grid-template-columns:1fr 1fr; gap:4rem; padding-top:1rem;
  h3 { margin-bottom:1rem; } p { font-size:1.6rem; max-width:60ch; }
  @media(max-width:767px){grid-template-columns:1fr;gap:2rem;}
`
export const Attribution = styled.div`
  margin-top:3rem; padding-top:2rem; border-top:1px solid var(--forecast-line); font-size:1.35rem;
  details{margin-top:1.5rem;} summary{cursor:pointer;min-height:4.4rem;display:flex;align-items:center;text-decoration:underline;text-underline-offset:.3rem;}
  dl{display:grid;grid-template-columns:auto 1fr;gap:.5rem 1.5rem;margin:1rem 0;} dd{margin:0;overflow-wrap:anywhere;}
  @media(max-width:479px){dl{grid-template-columns:1fr;gap:.3rem;}dd{margin-bottom:1rem;}}
`
export const Promo = styled.section`
  width:min(118rem,calc(100% - 4rem)); margin:1.5rem auto 3rem; padding:2.5rem 3rem;
  background:${palette.ink}; color:${palette.chalk}; border-radius:.6rem;
  h2{font-size:2.8rem;line-height:1.2;margin:0 0 1rem;} p{max-width:70ch;font-size:1.6rem;margin:.5rem 0 1.5rem;}
  div{display:flex;flex-wrap:wrap;gap:1rem 2rem;} a{text-decoration:underline;text-underline-offset:.4rem;min-height:4.4rem;display:flex;align-items:center;font-size:1.5rem;}
  @media(max-width:479px){padding:2rem;}
`
